// Older overall lens analyses stored representative_quotes as
// { quote, transcript_id, turn_id, match_score, name } objects after a
// since-removed worker post-processor enriched them. New runs store plain
// strings. Accept both so legacy analysis_items already in Mongo render.
export const getQuoteText = (q) => {
  if (q == null) return '';
  if (typeof q === 'string') return q;
  if (typeof q === 'object' && typeof q.quote === 'string') return q.quote;
  return '';
};
